import { DocumentDownload } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledDocumentWrapper = styled.div`
  position: relative;
  flex-wrap: wrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 0 ${rem('8px')} 0;
  border: ${rem('1px')} dashed;
  border-radius: ${rem('8px')};
  transition: all 0.2s;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.main};
`;

export const StyledInnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${rem('56px')};
  border-radius: ${rem('8px')};
  padding: ${rem('12px')} ${rem('16px')};
  position: relative;
`;

export const StyledDocumentTitle = styled.h5`
  margin: 0;
  color: ${({ theme }) => theme.colors.cross.deepBlu};
  font-size: ${rem('16px')};
  font-weight: 500;
  position: relative;
  z-index: 2;
  text-align: left;
`;

export const StyledNav = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  z-index: 2;
`;

export const StyledDocumentDownloadIcon = styled(DocumentDownload)`
  width: ${rem('24px')};
  height: auto;

  path {
    fill: ${({ theme }) => theme.colors.cross.grayson};
  }
`;

export const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  appearance: none;

  &:not(:first-child) {
    margin-left: ${rem('12px')};
  }
`;

export const StyledLabel = styled.h2`
  font-size: ${rem('16px')};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.cross.black};
  margin-bottom: ${rem('9px')};
`;
